<template>
  <button
    type="button"
    class="rounded-[2.4rem] shadow-[0px_6px_14px_0px_rgba(0,51,150,0.07)] bg-white overflow-hidden"
    :class="tutorial.isActive ? 'group cursor-pointer' : 'pointer-events-none'"
    @click="onClick"
  >
    <div class="w-full aspect-video overflow-hidden relative">
      <div
        v-if="!tutorial.isActive"
        class="flex items-center justify-center text-[1.6rem] text-center"
      >
        <span
          class="stds-text text-title4 leading-title4 font-bold absolute inset-0 bg-black/50 text-white flex items-center justify-center text-center"
        >
          <safe-html :html="ComingSooText" />
        </span>
      </div>
      <img
        class="group-hover:scale-105 w-full h-full object-contain transition-transform duration-500"
        :src="tutorial.image"
        :alt="tutorial.imageAlt"
      />
    </div>
    <div class="h-100 p-24">
      <s-text
        as="p"
        role="title7"
        class="!font-bold line-clamp-2 text-on-surface-elevation-1 text-left"
      >
        <safe-html :html="tutorial.title" />
      </s-text>
    </div>
  </button>
</template>
<script setup lang="ts">
import { computed, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';

import VideoContentDialog from '@/components/brand-page/video-content-dialog.vue';
import SafeHtml from '@/components/common/safe-html.vue';
import { showDialog } from '@/composables/useDialog';
import type { Tutorial } from '@/types/tutorial';

const { locale } = useI18n();

const props = defineProps<{
  tutorial: Tutorial;
}>();

const ComingSooText = computed(() => {
  return locale.value === 'ko' ? '튜토리얼 영상<br />공개 예정' : 'Tutorial Video<br />Coming Soon';
});

const onClick = () => {
  showDialog({
    component: shallowRef(VideoContentDialog),
    props: {
      thumbnailImage: props.tutorial.image,
      imageAlt: props.tutorial.imageAlt,
      title: props.tutorial.title,
      description: props.tutorial.description,
      srcVideo: props.tutorial.srcVideo
    },
    severity: 'info'
  });
};
</script>
